module.exports = __webpack_public_path__ + "d599744639b2bd4302231e9b29cbd9e9.png";